import {forwardRef, useImperativeHandle, useState} from "react";
import {Modal, Upload} from "antd";
import {IconClose} from "../../Icon";
import {useTranslation} from "react-i18next";
import {InboxOutlined} from "@ant-design/icons";
import Dragger from "antd/es/upload/Dragger";
import {blobToBase64, getImagePathWithTheme, imgPathPerfix, isImage, isZipFile} from "@/utils";
import JSZip from "jszip";
import {ZIP_DATA_DB_NAME} from "@/Const";
import {ipcInvoke} from "@/common/ipc";
import {blobToArrayBuffer} from "../../../@excalidraw/packages/excalidraw/data/blob";
import {isWeb} from "@/electron_interactive";
import {t} from "i18next";

const DialogImport = forwardRef((props:{onStartImport:any,onImportNoteData:any}, ref) => {
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }))

    const {t} = useTranslation();
    const [isVisible,setIsVisible] = useState(false);

    const onShowDialog = ()=>{
        setIsVisible(true)
    }

    const uploadProps:{ beforeUpload: (file) => string } = {
        beforeUpload:(file)=>{
            isZipFile(file).then(res=>{
                if (res){
                    if (props.onStartImport){
                        props.onStartImport();
                    }
                    let zip = new JSZip();
                    zip.loadAsync(file).then(async (zipData:any)=>{
                        //
                        let szDbData = '';
                        let hasContainFile = false;
                        for (const[name,zipFile] of Object.entries(zipData.files)){
                            if (name == ZIP_DATA_DB_NAME){
                                setIsVisible(false);
                                szDbData = await zipFile.async('string');
                            }else{
                                //保存到files文件夹
                                const blob = await zipFile.async('blob');
                                let arrayBuffer = await blobToArrayBuffer(blob);
                                await ipcInvoke('write-one-buffer-files',{fileName:name,data:arrayBuffer});
                                if (!isImage(name)){
                                    hasContainFile = true;
                                }
                            }
                        }
                        if (isWeb() && hasContainFile){
                            //这里提示是否导入
                            window.closeIndicator();
                            window.showMessageBox(t("Tips"),t("ContainFilesContinueImport"),t("Cancel"),t("Import"),null,()=>{
                                window.showIndicator();
                                props.onImportNoteData(szDbData,file.path || file.name);
                            });
                        }else{
                            props.onImportNoteData(szDbData,file.path || file.name);
                        }
                        // console.log(zipData);
                    })
                }else{
                    let reader = new FileReader();
                    reader.onload = function (e){
                        setIsVisible(false);
                        const szImportData = e.target.result as string;
                        if (isWeb()){
                            const importData = JSON.parse(szImportData);
                            if (importData.files && importData.files.length > 0) {
                                //这里提示是否导入
                                window.closeIndicator();
                                window.showMessageBox(t("Tips"),t("ContainFilesContinueImport"),t("Cancel"),t("Import"),null,()=>{
                                    window.showIndicator();
                                    props.onImportNoteData(szImportData,file.path || file.name);
                                });
                            }else{
                                window.showIndicator();
                                props.onImportNoteData(szImportData,file.path || file.name);
                            }
                        }else{
                            props.onImportNoteData(szImportData,file.path || file.name);
                        }
                    }
                    reader.readAsText(file,"utf-8");
                }
            })

            return Upload.LIST_IGNORE
        }
    }

    return(
        <Modal centered={true} width='488px' bodyStyle={{}} visible={isVisible} closeIcon={<IconClose/>} onCancel={()=>setIsVisible(false)} footer={''}>
            <div style={{display:'flex',flexDirection:'column'}} className={'font-size-12'}>
                <span className='header-title'>{t("Import canvas file")}</span>
                {/*<span style={{fontSize:'13px',marginTop:'2px'}}>{t("Import a canvas file here")}</span>*/}

                <div style={{marginTop:'12px',borderRadius:'8px',
                    marginBottom:'8px', backgroundColor:'var(--drag-file-background-color)',
                    height:'172px',display:'flex',alignItems:'center',justifyContent:'center'
                }}>
                    <Dragger {...uploadProps} accept={".pcanvas,.pcanvasx"} style={{outline:'none',border:'0px',backgroundColor:'transparent',width:'100%',height:'100%'}}>
                        <p className="ant-upload-text">
                            <img style={{width:'88px',height:'88px'}} src={getImagePathWithTheme("drag_import")}/>
                        </p>
                        <p style={{color:'var(--drag-file-desc-color)'}}>{t("Click here or drag")}</p>
                    </Dragger>
                </div>

            </div>

        </Modal>
    )
})

export default DialogImport;













